<template>
<div>
  <div class="title">{{`${scoreType==='plus'?'+':'-'}1分`}}</div>
  <div>
    <el-select
        id="select-input"
      v-model="reason"
      filterable
      allow-create
      default-first-option
      style="width: 100%"
        @visible-change="removeSelectReadyOnly"
        @blur="removeSelectReadyOnly"
        @focus="removeSelectReadyOnly"
      :placeholder="`选择或输入${scoreType==='plus'?'加':'减'}分事由`">
    <el-option
        v-for="item in reasonOptions"
        :key="item.value"
        :label="item.label"
        :value="item.reason">
      <div class="reason-option">
        <div>
          <span>{{item.reason}}</span>
        </div>
        <div class="info">
          <span>{{`使用${item.count}次`}}</span>
          <span style="margin-left: 6px">{{`${timeAgo(formatDateStrFromUTC(item.latest_create_time))}使用`}}</span>
        </div>
      </div>
    </el-option>
  </el-select>
  </div>
  <el-button class="btn"  @click="addRecord" type="primary" plain>确认</el-button>
</div>
</template>

<script>
import {addScoreRecord, searchScoreReasonsByCount} from "@/api/api";
import {formatDateTime,timeAgo,formatDateStrFromUTC} from "@/util/time";

export default {
  name: "AddScoreRecord",
  props:{
    scoreType:{
      type:String,
    }
  },
  data(){
    return {
      reason:'',
      reasonOptions:[]
    }
  },
  mounted() {
    this.removeSelectReadyOnly()
    this.searchScoreReasonsByCount()
  },
  methods:{
    formatDateTime,timeAgo,formatDateStrFromUTC,
    addRecord(){
      addScoreRecord({score:this.scoreType==='plus'?1:-1,reason:this.reason}).then(res=>{
        if(res.code===0){
          this.$message({
            message:this.scoreType==='plus'?'成功添加！每天都有新进步哦~':'添加记录，不要灰心呀~',
            type: 'success'
          });
        }else{
          this.$message('error');
        }
        this.$emit('added')
      }).catch(err=>{
        console.log(err)
      })
    },

    searchScoreReasonsByCount(){
      searchScoreReasonsByCount({score_type:this.scoreType==='plus'?1:-1}).then(res=>{
        console.log(res)
        this.reasonOptions=res.data
      }).catch(err=>{
        console.log(err)
      })
    },
    removeSelectReadyOnly(){
      document.getElementById("select-input").removeAttribute("readOnly")
    }
  }
}
</script>

<style lang="scss" scoped>
.title{
  font-size: 20px;
  margin-bottom: 10px;
}
.reason-option{
  display: flex;
  align-items: center;
  justify-content: space-between;
  .info{
    font-size: 12px;
    font-style: italic;
    color: #aaa;
  }
}
.btn{
  margin-top: 10px;
  width: 100%;
}
</style>